import { forwardRef } from "react";
import type { TreeItemComponentProps } from "dnd-kit-sortable-tree";
import { SimpleTreeItemWrapper } from "dnd-kit-sortable-tree";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { Icon } from "@circle-react-shared/Icon";

export interface TreeItem {
  children?: TreeItem[];
  collapsed?: boolean;
  id: string;
  type: string;
}

export const LayersTreeItem = forwardRef<
  HTMLDivElement,
  TreeItemComponentProps<TreeItem>
>(({ item, depth, onCollapse, ...props }, ref) => {
  const hasChildren = item.children && item.children.length > 0;
  const isExpanded = hasChildren && !item.collapsed;

  return (
    <SimpleTreeItemWrapper
      {...props}
      ref={ref}
      item={item}
      depth={depth}
      className="bg-primary hover:bg-secondary py-2 transition-colors"
      contentClassName="!border-none !p-0"
      aria-level={depth}
    >
      {hasChildren ? (
        <button
          type="button"
          className="flex w-full items-center gap-2 text-left"
          aria-expanded={isExpanded}
          onClick={onCollapse}
        >
          <span className="flex">
            <Icon
              type="16-chevron-right"
              size={16}
              className={classNames("size-4 transition-all", {
                "rotate-90": isExpanded,
              })}
            />
          </span>
          <span>{item.type}</span>
        </button>
      ) : (
        <div className="flex w-full items-center gap-2">
          <span>{item.type}</span>
        </div>
      )}
    </SimpleTreeItemWrapper>
  );
});

LayersTreeItem.displayName = "LayersTreeItem";
